import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../common/Modal';

const ConnectProducts = ({ matchedItems, handleModalClose, handleConnect, handleSubmitWithoutConnection, openedIsOn, vendorName }) => (
  <Modal
    className="shopify-modal shopify-connect-products-modal first-connection"
    display-if={openedIsOn}
    title="Connect Products"
    close={handleModalClose}
    showCloseButton
  >
    <div className="modal-container">
      <div className="modal-container__body">
        {/* Only the first match is relevant. Matches filters on a backend */}
          The SKU matches {matchedItems[0].name} in {vendorName}
        <p>Would you like to connect these products?</p>
      </div>
    </div>
    <div className="modal-controls">
      <button
        type="button"
        className="c-btn c-btn--medium c-btn--grey"
        onClick={handleSubmitWithoutConnection}
      >
        <span className="c-btn__text">No</span>
      </button>
      <button
        type="button"
        className="c-btn c-btn--medium"
        /* Only the first match is relevant. Matches filters on a backend */
        onClick={() => handleConnect(matchedItems[0].remoteIdentifier)}
      >
        <span className="c-btn__text">Ok</span>
      </button>
    </div>
  </Modal>
  );

ConnectProducts.propTypes = {
  handleModalClose: PropTypes.bool.isRequired,
  matchedItems: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    remoteIdentifier: PropTypes.string.isRequired,
  })).isRequired,
  handleConnect: PropTypes.func.isRequired,
  handleSubmitWithoutConnection: PropTypes.func.isRequired,
  openedIsOn: PropTypes.bool.isRequired,
  vendorName: PropTypes.string.isRequired,
};

export default ConnectProducts;
